<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Sorteo Global">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="sorteoGlobalDatos"
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'sorteosGlobales/getField',
  mutationType: 'sorteosGlobales/updateField',
});

export default {
  name: 'SorteoGlobalDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      sorteoGlobalId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
    }
  },
  created() {
    this.sorteoGlobalId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('sorteosGlobales/getDatos', this.sorteoGlobalId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  computed: {
    ...mapFields([
      'sorteoGlobalDatos',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
